export const blockIconsCommunicationQrCode = (
	<span className='material-symbols-outlined'>qr_code</span>
);
